(function (root) {
  'use strict';
  const US_COUNTRIES = new Set(['US', 'PR', 'VI', 'GU', 'AS', 'MP', 'UM']);
  const PREFERENCE = 'ogw.measurements.v1';
  const GEO_CACHE = 'ogw.measurements.country.v1';
  const NUMBER = String.raw`-?(?:\d{1,3}(?:[,\u00a0\u202f ]\d{3})+|\d+)(?:[.,]\d+)?`;
  const RANGE = `(${NUMBER})(?:\\s*(?:[–−-]|to|à|a)\\s*(${NUMBER}))?`;
  const UNIT = String.raw`(?:litres?|liters?|litros?|l)(?:\s*(?:\/|per\s+|par\s+|por\s+)(?:minutes?|mins?|hours?|hrs?|heures?|days?|jours?|minutos?|horas?|días?|[mhd]))?|lpm|lph|lpd|centimet(?:re|er)s?|millimet(?:re|er)s?|met(?:re|er)s?|cm|mm|m|kilograms?|kilogrammes?|kg|°\s*C`;
  const QUANTITY = new RegExp(`(?<![\\p{L}\\p{N}_.\\/])${RANGE}\\s*(${UNIT})(?![\\p{L}\\p{N}²³^\\/])`, 'giu');
  const DIMENSIONS = new RegExp(String.raw`(?<![\p{L}\p{N}_.])(?:[WLHD]\s*)?${NUMBER}\s*(?:cm|mm)?\s*[×x]\s*(?:[WLHD]\s*)?${NUMBER}\s*(?:cm|mm)?(?:\s*[×x]\s*(?:[WLHD]\s*)?${NUMBER}\s*)?(?:cm|mm)\b`, 'giu');
  const EXCLUDE = 'script,style,noscript,svg,math,canvas,textarea,input,select,code,pre,iframe,h1,[contenteditable="true"],[data-ogw-no-convert],[data-ogw-unit-toggle],[data-product-title],.product-title,.product-card__title,[class*="review"],[id*="review"],.shopify-policy__container';
  function number(value) {
    let text = value.replace(/[\s\u00a0\u202f]/g, '');
    text = /^-?\d{1,3}(,\d{3})+(\.\d+)?$/.test(text) ? text.replace(/,/g, '') : text.replace(',', '.');
    return Number(text);
  }
  function format(value, digits) {
    return String(Number(value.toFixed(digits)));
  }
  function convert(value, unit) {
    const u = unit.toLowerCase().replace(/\s+/g, '');
    if (/^(?:l(?:it(?:re|er|ro)s?)?)(?:$|\/|per|par|por|p[mdh])/.test(u)) {
      const amount = value / 3.785411784;
      const suffix = /(?:lpm|minute|minuto|\/min|\/m$)/.test(u) ? '/min' : /(?:lph|hour|heure|hora|\/h)/.test(u) ? '/hour' : /(?:lpd|day|jour|día|\/d)/.test(u) ? '/day' : '';
      return {value: amount, digits: Math.abs(amount) < 1 ? 2 : 1, unit: 'US gal' + suffix};
    }
    if (/^(?:cm|centimet)/.test(u)) return {value: value / 2.54, digits: 1, unit: 'in'};
    if (/^(?:mm|millimet)/.test(u)) return Math.abs(value) < 1 ? null : {value: value / 25.4, digits: 2, unit: 'in'};
    if (/^(?:m|metre|meter)s?$/.test(u)) return {value: value / 0.3048, digits: 1, unit: 'ft'};
    if (/^(?:kg|kilogram)/.test(u)) return {value: value / 0.45359237, digits: 1, unit: 'lb'};
    if (/^°c$/.test(u)) return {value: value * 9 / 5 + 32, digits: 1, unit: '°F'};
    return null;
  }
  function toUS(text) {
    const dimensions = [];
    const protectedText = text.replace(DIMENSIONS, match => {
      const lastUnit = match.match(/(cm|mm)$/i)[1].toLowerCase();
      const parts = match.split(/\s*[×x]\s*/i).map(part => {
        const parsed = part.match(new RegExp(`^([WLHD]?)\\s*(${NUMBER})\\s*(cm|mm)?$`, 'i'));
        if (!parsed) return null;
        const converted = convert(number(parsed[2]), parsed[3] || lastUnit);
        return converted ? parsed[1] + format(converted.value, converted.digits) : null;
      });
      if (parts.some(part => part === null)) return match;
      const index = dimensions.push(parts.join(' × ') + ' in') - 1;
      return `\uE000${index}\uE001`;
    });
    return protectedText.replace(QUANTITY, (match, first, second, unit) => {
      const a = convert(number(first), unit);
      const b = second === undefined ? null : convert(number(second), unit);
      if (!a || (second !== undefined && !b)) return match;
      const digits = b ? Math.max(a.digits, b.digits) : a.digits;
      return format(a.value, digits) + (b ? '–' + format(b.value, digits) : '') + ' ' + a.unit;
    }).replace(/\uE000(\d+)\uE001/g, (_, index) => dimensions[Number(index)]);
  }
  function countryUnits(country) { return US_COUNTRIES.has(String(country).toUpperCase()) ? 'us' : 'metric'; }
  const api = {toUS, countryUnits};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!root.document || root.OGWUnits) return;
  root.OGWUnits = api;
  const document = root.document;
  const configNode = document.getElementById('ogw-unit-config');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  const main = document.getElementById('main');
  if (!main) return;
  function read(storage, key) { try { return root[storage].getItem(key); } catch (_) { return null; } }
  function write(storage, key, value) { try { root[storage].setItem(key, value); } catch (_) {} }
  function preference() { const value = read('localStorage', PREFERENCE); return value === 'metric' || value === 'us' ? value : null; }
  let manual = preference();
  let units = manual || countryUnits(config.country);
  const records = new Map();
  let cachedCountry;
  try {
    const cached = JSON.parse(read('sessionStorage', GEO_CACHE));
    if (cached && typeof cached.country === 'string' && Date.now() - cached.time < 7200000) cachedCountry = cached.country;
  } catch (_) {}
  if (!manual && cachedCountry) units = countryUnits(cachedCountry);
  function eligible(node) { return node.parentElement && main.contains(node) && !node.parentElement.closest(EXCLUDE); }
  function process(node) {
    if (!eligible(node)) return;
    const existing = records.get(node);
    if (existing && node.nodeValue === existing.last) return;
    const metric = node.nodeValue;
    const us = toUS(metric);
    if (metric === us) { records.delete(node); return; }
    const record = {metric, us, last: units === 'us' ? us : metric};
    records.set(node, record);
    if (node.nodeValue !== record.last) node.nodeValue = record.last;
  }
  function scan(element) {
    if (element.nodeType === 3) return process(element);
    if (element.nodeType !== 1 || element.closest(EXCLUDE)) return;
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) process(walker.currentNode);
  }
  function controls() {
    document.querySelectorAll('[data-ogw-units-slot]').forEach(slot => { slot.hidden = false; });
    document.querySelectorAll('[data-ogw-unit-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ogwUnitChoice === units)));
    document.documentElement.dataset.ogwUnits = units;
  }
  function select(value, remember, announce) {
    if (value !== 'metric' && value !== 'us') return;
    if (remember) { manual = value; write('localStorage', PREFERENCE, value); }
    units = value;
    records.forEach((record, node) => {
      if (!eligible(node)) { records.delete(node); return; }
      if (node.nodeValue !== record.last) { process(node); return; }
      record.last = units === 'us' ? record.us : record.metric;
      if (node.nodeValue !== record.last) node.nodeValue = record.last;
    });
    controls();
    if (announce) {
      const status = document.getElementById('ogw-unit-status');
      if (status) status.textContent = units === 'us' ? config.usStatus : config.metricStatus;
    }
    document.dispatchEvent(new CustomEvent('ogw:units-changed', {detail: {units}}));
  }
  scan(main);
  controls();
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-ogw-unit-choice]');
    if (button) select(button.dataset.ogwUnitChoice, true, true);
  });
  root.addEventListener('storage', event => {
    if (event.key === PREFERENCE) { manual = preference(); select(manual || countryUnits(cachedCountry || config.country), false, false); }
  });
  document.addEventListener('shopify:section:load', event => { scan(event.target); controls(); });
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'characterData') process(mutation.target);
      else mutation.addedNodes.forEach(scan);
    });
    records.forEach((_, node) => { if (!node.isConnected) records.delete(node); });
  });
  observer.observe(main, {childList: true, subtree: true, characterData: true});
  api.units = () => units;
  if (!manual && !cachedCountry && !config.designMode) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 3500);
    const path = (config.root || '/') + 'browsing_context_suggestions.json?country[enabled]=true';
    fetch(path, {credentials: 'same-origin', signal: controller.signal})
      .then(response => response.ok ? response.json() : null)
      .then(data => {
        const country = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        if (typeof country !== 'string' || !/^[A-Z]{2}$/.test(country)) return;
        cachedCountry = country;
        write('sessionStorage', GEO_CACHE, JSON.stringify({country, time: Date.now()}));
        if (!manual && !preference()) select(countryUnits(country), false, false);
      })
      .catch(() => {})
      .finally(() => clearTimeout(timer));
  }
})(typeof window !== 'undefined' ? window : globalThis);
